import React, { useState } from "react";
import { Form, Input, Button, message, Card, Typography } from "antd";
import { LockOutlined, UserOutlined } from "@ant-design/icons";
import axios from "axios";
import "./Login.css";
import { useNavigate } from "react-router-dom";
import loginImg from "../assets/login.jpg.png";
import forgotImg from "../assets/resetPass.png";


const { Title } = Typography;
const BASEURL = process.env.REACT_APP_BASEURL;

const LoginForm = () => {
  const [isForgotPassword, setIsForgotPassword] = useState(false); 
  const navigate = useNavigate();



  const handleLoginSubmit = async (values) => {
    try {
      const response = await axios.post(
        `${BASEURL}/auth/login`,
        {
          empno: values.empno,
          password: values.password,
        }
      );
  
      const { accessToken, refreshToken, user } = response.data;
      message.success("Login successful!");
  
      localStorage.setItem("accessToken", accessToken);
      localStorage.setItem("refreshToken", refreshToken);
      localStorage.setItem("user", JSON.stringify(user));
      navigate("/dashboard");
    } catch (error) {
      if (error.response) {
        // Server responded with a status other than 2xx
        message.error(
          error.response.data.message || "Login failed. Please try again."
        );
      } else if (error.request) {
        // Request was made but no response received
        message.error("Network error. Please check your connection.");
      } else {
        // Something else happened
        message.error("An unexpected error occurred. Please try again.");
      }
    }
  };
  
  const handleForgotPasswordSubmit = async (values) => {
    try {
      await axios.post(
         `${BASEURL}/auth/reset-password-email`,
        {
          empno: values.empno,
        }
      );
  
      message.success("Password reset link sent to your registered email!");
      setIsForgotPassword(false); // Navigate back to login
    } catch (error) {
      if (error.response) {
        // Server responded with a status other than 2xx
        message.error(
          error.response.data.message || "Failed to reset password. Please try again."
        );
      } else if (error.request) {
        // Request was made but no response received
        message.error("Network error. Please check your connection.");
      } else {
        // Something else happened
        message.error("An unexpected error occurred. Please try again.");
      }
    }
  };
  

  return (
    <div className="login-container">
      <div className="login">
        <div className="login-grid">
          {/* Left Column: Animated Image */}
          <div className={`login-image-container ${isForgotPassword ? "image-slide-out" : "image-slide-in"}`}>
            <img
              src={isForgotPassword ? forgotImg : loginImg}
              alt={isForgotPassword ? "Forgot Password" : "Login"}
              className="login-image"
            />
          </div>

          {/* Right Column: Form */}
          <div className="login-form-container">
            <div className="form-wrapper">
              <Title level={2} className="login-title">
                {isForgotPassword ? "Reset Password" : "Welcome Back!"}
              </Title>
              <Card
                title={isForgotPassword ? "Forgot Password" : "Employee Login"}
                style={{ width: 400, borderRadius: "8px" }}
              >
                <Form
                  name={isForgotPassword ? "forgotPassword" : "login"}
                  onFinish={
                    isForgotPassword ? handleForgotPasswordSubmit : handleLoginSubmit
                  }
                  layout="vertical"
                >
                  <Form.Item
                    label="Employee Number"
                    name="empno"
                    rules={[{ required: true, message: "Please input your employee number!" }]}
                  >
                    <Input
                      prefix={<UserOutlined />}
                      placeholder="Enter your employee number"
                    />
                  </Form.Item>

                  {/* Password Field for Login */}
                  {!isForgotPassword && (
                    <Form.Item
                      label="Password"
                      name="password"
                      rules={[{ required: true, message: "Please input your password!" }]}
                    >
                      <Input.Password
                        prefix={<LockOutlined />}
                        placeholder="Enter your password"
                      />
                    </Form.Item>
                  )}

                  <Form.Item>
                    <Button type="primary" htmlType="submit" block>
                      {isForgotPassword ? "Reset Password" : "Login"}
                    </Button>
                  </Form.Item>

                  {/* Toggle Link */}
                  <Form.Item>
                    <Button
                      type="link"
                      block
                      onClick={() => setIsForgotPassword(!isForgotPassword)}
                    >
                      {isForgotPassword ? "Back to Login" : "Forgot Password?"}
                    </Button>
                  </Form.Item>
                </Form>
              </Card>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginForm;
